
import Button from '../../../components/base/Button';

export default function ContactSection() {
  return (
    <section id="contact" className="py-20 bg-gray-50 text-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            お気軽にお問い合わせください
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            ご予約やご相談など、どんなことでもお気軽にお声かけください
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* 連絡先情報 */}
          <div>
            <h3 className="text-2xl font-semibold mb-8">アクセス・診療時間</h3>
            
            <div className="space-y-6">
              <div className="flex items-start">
                <div className="w-8 h-8 bg-[#3cb371] rounded-full flex items-center justify-center mr-4 mt-1">
                  <i className="ri-map-pin-line text-white"></i>
                </div>
                <div>
                  <h4 className="font-semibold mb-1">住所</h4>
                  <p className="text-gray-600">〒123-4567<br />東京都渋谷区○○町1-2-3<br />○○ビル2F</p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-8 h-8 bg-[#3cb371] rounded-full flex items-center justify-center mr-4 mt-1">
                  <i className="ri-phone-line text-white"></i>
                </div>
                <div>
                  <h4 className="font-semibold mb-1">電話番号</h4>
                  <p className="text-gray-600">〇〇〇-□□□□-××××</p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-8 h-8 bg-[#3cb371] rounded-full flex items-center justify-center mr-4 mt-1">
                  <i className="ri-time-line text-white"></i>
                </div>
                <div>
                  <h4 className="font-semibold mb-1">診療時間</h4>
                  <div className="text-gray-600 space-y-1">
                    <p>平日：9:00 - 20:00</p>
                    <p>土日：9:00 - 18:00</p>
                    <p className="text-red-500">定休日：月曜日</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-8">
              <Button className="w-full sm:w-auto">
                <i className="ri-map-line mr-2"></i>
                Googleマップで見る
              </Button>
            </div>
          </div>

          {/* お問い合わせフォーム */}
          <div>
            <h3 className="text-2xl font-semibold mb-8">お問い合わせフォーム</h3>
            
            <div className="bg-white rounded-lg p-6 shadow-lg">
              <div className="space-y-6">
                <div>
                  <label className="block text-sm font-medium mb-2">お名前 *</label>
                  <input 
                    type="text" 
                    className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-full text-gray-900 placeholder-gray-500 focus:outline-none focus:border-[#3cb371] transition-colors"
                    placeholder="山田 太郎"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium mb-2">電話番号 *</label>
                  <input 
                    type="tel" 
                    className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-full text-gray-900 placeholder-gray-500 focus:outline-none focus:border-[#3cb371] transition-colors"
                    placeholder="090-1234-5678"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium mb-2">お問い合わせ内容 *</label>
                  <textarea 
                    rows={4}
                    className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-lg text-gray-900 placeholder-gray-500 focus:outline-none focus:border-[#3cb371] transition-colors resize-none"
                    placeholder="ご相談内容をお聞かせください"
                  ></textarea>
                </div>

                <Button className="w-full">
                  <i className="ri-send-plane-line mr-2"></i>
                  送信する
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
